<template>
  <div class="d-flex flex-wrap align-center">
    <label class="mx-2" for="selection-mode">{{ label }}</label>
    <slot></slot>
    <v-btn-toggle :id="id" v-model="mode" mandatory class="mr-4">
      <v-btn
        v-for="mode in modes"
        :key="mode.value"
        :value="mode.value"
        small
        color="transparent"
        elevation="2"
      >
        {{ mode.text }}
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    modes: {
      type: Array,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    mode: {
      get() {
        return this.value;
      },
      set(v) {
        return this.$emit("input", v);
      }
    }
  }
};
</script>
